import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import LogoImg from "../../Images/zbizLogo.png";
import { NavLink } from "react-router-dom";
import { useFormik } from "formik";
import classNames from "classnames";
import SubmitButton from "../../components/submitButton/SubmitButton";
import styled, { keyframes } from "styled-components";
import { handlePostRequest } from "../../services/PostTemplate";
import { Password } from "primereact/password";

// Keyframes for animation
const fadeInZoom = keyframes`
  0% { 
    opacity: 0;
    transform: scale(0.5);
  }
  100% { 
    opacity: 1;
    transform: scale(1);
  }
`;

// Creating a Styled Component for logo
const StyledLogo = styled.img`
  animation: ${fadeInZoom} 5s ease-in-out;
`;

const Login = ({ onLoginSuccess }) => {
  const [loading, setloading] = useState(false);
  // const [obscuredPassword, setObscuredPassword] = useState("");

  let history = useHistory();

  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.userName) {
        errors.userName = "Username is required.";
      }
      if (!data.password) {
        errors.password = "Password is required.";
      }
      return errors;
    },
    onSubmit: async (data) => {
      setloading(true);
      // data.password = obscuredPassword; // set password to the value of the obscured password

      try {
        const res = await handlePostRequest(data, "zbizgateway/login");

        if (res?.responsecode === 1) {
          await onLoginSuccess(data.userName);
        }

        if (res.status === 400) {
          res?.data.forEach((element) => {
            formik.setFieldError(element?.field, element?.message);
          });
        }

        if (res?.data?.login) {
          if (res?.data?.tblUser?.pwdUpdateFlag === "Y") {
            history.push("/");
          } else {
            history.push("/resetpassword");
          }
        }
      } catch (error) {
        // handle your error here, such as logging it or displaying an error message
        console.error(error);
        console.log(
          "error.response.data.messages",
          error.response.data.messages
        );
      } finally {
        setloading(false);
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  return (
    <div className="Login__Body">
      <div className="p-mb-4" style={{ width: "20%" }}>
        <StyledLogo src={LogoImg} alt="zbizz logo" />
      </div>
      <div className="container_login" id="container">
        <div className="form-container sign-in-container">
          <form
            action="#"
            className="Login__Form"
            onSubmit={formik.handleSubmit}
            autoComplete="off"
          >
            <div>
              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  color: "#ffffff",
                  textAlign: "center",
                }}
              >
                Corporate Portal
              </h3>
            </div>
            <div className="p-mt-4">
              <div className="p-field p-text-left">
                <div className="flex flex-column w-12">
                  <span className="p-input-icon-left">
                    <i className="pi pi-envelope"></i>
                    <input
                      autoComplete="off"
                      id="userName"
                      className={classNames(
                        { "p-invalid": isFormFieldValid("userName") },
                        "Login__Input"
                      )}
                      name="userName"
                      value={formik.values.userName}
                      placeholder="Enter Username"
                      onChange={formik.handleChange}
                      type="search"
                    />
                    {getFormErrorMessage("userName")}
                  </span>
                </div>
              </div>
              <div className="p-field p-text-left">
                <div className="flex flex-column w-12">
                  <span className="p-input-icon-left">
                    <i className="pi pi-lock" style={{ zIndex: "1" }}></i>
                    <Password
                      autoComplete="off"
                      className={classNames("Pass__Input", {
                        "p-invalid": isFormFieldValid("password"),
                      })}
                      name="password"
                      placeholder="Enter Password"
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      toggleMask
                      feedback={false}
                    />
                    {getFormErrorMessage("password")}
                  </span>
                </div>
              </div>
              <div className="forgot_div mb-30 p-field">
                <NavLink to="/forgetpassword" className="reset_pass">
                  Forgot Password?
                </NavLink>
              </div>
              <div className="p-mt-4">
                <SubmitButton
                  label="Login"
                  loading={loading}
                  className="Login__Button"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
